/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { useLocale } from '@adsk/alloy-react-locale';
import { AutocompleteOrManualAddress } from '@adsk/acs-admin-ui-components-shared-components';
import FieldWrapper from '../FieldWrapper';
import { addressProps } from '../../../propTypes';
import { getCountryStateNames } from '../../utils';

const AddressField = ({
  address,
  autocompletedAddress,
  mapBoxAccessToken,
  inputMode,
  isEditing,
  isMapboxTokenActive,
  onAddressChange,
  onAutocompletedAddressResult,
  onInputModeChange,
  setMapboxTokenActive,
  title,
}) => {
  const { T } = useLocale(({ locale }) =>
    require(`../../../../i18n/${locale}.json`)
  );
  const { country, stateOrProvince } = address;
  const { countryName, stateName } = getCountryStateNames(
    country,
    stateOrProvince
  );

  const content = isEditing ? (
    <AutocompleteOrManualAddress
      address={address}
      autocompletedAddress={autocompletedAddress}
      inputMode={inputMode}
      isMapboxTokenActive={isMapboxTokenActive}
      mapBoxAccessToken={mapBoxAccessToken}
      onInputModeChange={onInputModeChange}
      onAutocompletedAddressResult={onAutocompletedAddressResult}
      onAddressChange={onAddressChange}
      resetAddressOnDelete
      setMapboxTokenActive={setMapboxTokenActive}
    />
  ) : (
    <>
      {(address.addressLine1 || address.addressLine2) && (
        <span>
          {address.addressLine1}
          {address.addressLine1 && address.addressLine2 && ', '}
          {address.addressLine2}
          <br />
        </span>
      )}
      {(address.city || address.stateOrProvince || address.postalCode) && (
        <span>
          {address.city}
          {address.city &&
            (address.stateOrProvince || address.postalCode) &&
            ', '}
          {stateName}
          {address.stateOrProvince && address.postalCode && ' '}
          {address.postalCode}
          <br />
        </span>
      )}
      {country && (
        <span>
          {countryName}
          <br />
        </span>
      )}
      {!address.country &&
        !address.postalCode &&
        !address.city &&
        !address.stateOrProvince &&
        !address.addressLine2 &&
        !address.addressLine1 &&
        T.translate('PROJECT_NOT_AVAILABLE')}
    </>
  );

  return (
    <FieldWrapper isEditing={isEditing} title={title}>
      {content}
    </FieldWrapper>
  );
};

AddressField.propTypes = {
  address: PropTypes.shape({ ...addressProps }),
  isEditing: PropTypes.bool,
  mapBoxAccessToken: PropTypes.string,
  onChange: PropTypes.func,
};

export default AddressField;
